import {OctTable} from "@oceantech/oceantech-ui";
import {Dispatch, SetStateAction, useContext, useEffect, useState} from "react";
import {XayDungKeHoachContext} from "../CoSoKBCB";
import '../XayDungKeHoach.scss';
import {TableCustomHeader} from "../../../../component/table/components/TableCustomHeader";
import {DanhSachPhieuInterface} from "../models/KeHoachModel";
import {formatDateToDDMMYYYY} from "../../../../utils/FormatUtils";
import {searchdsDot} from "../services/services";
import {CODE} from "../../../../utils/Constant";
import {STATUS} from "../constants/constansKeHoach";

interface Props {
  isView?: boolean;
  setInitialValuesFormThemVT: Dispatch<SetStateAction<any>>,
  handleEdit: (row: any, index: number) => void;
  handleView: (row: any, index: number) => void;
  dsDot: any[];
}

const TableThongTinDot = (props: Props) => {
  const {isView, handleEdit, handleView, dsDot} = props;
  const isEditable = (index: number, dsDot: any[]) => {
    // Nếu tất cả đều hoàn tất → không sửa được gì
    const isAllDone = dsDot.every(item => item.statusCode === 'deployed');
    if (isAllDone) return false;

    const currentStatus = dsDot[index]?.statusCode;

    // Đợt đã hoàn tất → không sửa
    if (currentStatus === 'deployed') return false;

    // Đợt đầu tiên: chưa hoàn tất thì cho sửa
    if (index === 0) return true;

    // Các đợt sau: chỉ cho sửa khi đợt trước đã hoàn tất
    return dsDot[index - 1]?.statusCode === 'deployed';
  };

  const columns = [
    {
      name: "STT",
      field: "",
      headerStyle: {
        width: 80,
      },
      cellStyle: {
        textAlign: "center",
      },
      render: (row: any, index: number, stt: number) => stt,
    },
    ...(!isView ?
      [
        {
          name: "Thao tác",
          field: "",
          headerStyle: {
            width: 80,
          },
          cellStyle: {
            textAlign: "center",
          },
          render: (row: any, index: number) => {
            const editable = isEditable(index, dsDot);

            return (
              <div className="d-flex justify-content-center align-items-center  gap-3">
                {editable && <i
                    onClick={() => handleEdit(row, index)}
                    className={`bi bi-pencil-square ${
                      editable ? 'text-navy cursor-pointer' : 'text-muted'
                    }`}
                    title={editable ? 'Chỉnh sửa' : 'Không được phép chỉnh sửa'}
                />}
                {row?.statusCode === 'deployed' && (
                  <i
                    onClick={() => handleView(row, index)}
                    className={`bi-eye ${
                      editable ? 'text-navy cursor-pointer' : 'text-muted'
                    }`}
                    title={editable ? 'Chỉnh sửa' : 'Không được phép chỉnh sửa'}
                  />
                  )}
              </div>
            );
          }

        },
      ] : []),
    {
      name: "Trạng thái",
      field: "color",
      headerStyle: {
        maxWidth: 100,
      },
      cellStyle: {
        textAlign: "left",
      },
      render: (row: any, index: number, stt: number) => STATUS[row.statusCode ?? '1']?.name,
    },
    {
      name: "Đợt",
      field: "time",
      headerStyle: {
        minWidth: 120,
      },
      cellStyle: {
        textAlign: "center",
      },
      render: (row: any, index: number, stt: number) => `Đợt ${index + 1}`,
    },
    {
      name: "Thời gian bắt đầu",
      field: "startTime",
      headerStyle: {
        minWidth: 120,
      },
      cellStyle: {
        textAlign: "center",
      },
      render: (row: any, index: number, stt: number) => formatDateToDDMMYYYY(row.startTime || row.item?.startTime || ''),
    },
    // {
    //   name: "Thời gian kết thúc",
    //   field: "endTime",
    //   headerStyle: {
    //     minWidth: 120,
    //   },
    //   cellStyle: {
    //     textAlign: "center",
    //   },
    //   render: (row: any, index: number, stt: number) => formatDateToDDMMYYYY(row.endTime || row.item?.endTime || ''),
    // },
    // {
    //   name: "Hình thức thực hiện",
    //   field: "implMethodName",
    //   headerStyle: {
    //     minWidth: 200,
    //   },
    //   cellStyle: {
    //     textAlign: "left",
    //   },
    //   render: (row: any, index: number, stt: number) => row.implMethodName || row.item?.implMethodName || '',
    // },
  ];

  return (
    <div className="spaces mt-12 border-table custom-table">
      <OctTable
        id="table-tt-nhap-thuoc"
        className={`spaces custom-header-table ${isView ? 'table-view-tt-ke-hoach' : 'table-tt-ke-hoach'}`}
        columns={columns}
        data={dsDot}
        noToolbar
        clearToolbar
        noPagination
        fixedColumnsCount={-1}
      />
    </div>
  );
};

export default TableThongTinDot;
